import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-main-kine',
  imports: [RouterOutlet],
  templateUrl: './main-kine.component.html',
  styleUrl: './main-kine.component.scss'
})
export class MainKineComponent {}
